import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';

export const PaxCounterCms: Record<PaxTypeCode, number> = {
    [PaxTypeCode.ADULT]: 130958,
    [PaxTypeCode.BOOK]: 134329,
    [PaxTypeCode.CHILD]: 130959,
    [PaxTypeCode.INFANT]: 130960,
    [PaxTypeCode.PERSON]: 134329,
    [PaxTypeCode.SENIOR]: 130961,
    [PaxTypeCode.UNKNOWN]: 130808,
    [PaxTypeCode.YOUTH]: 130962,
    [PaxTypeCode.TODDLER]: 156688,
    [PaxTypeCode.STUDENT]: 156689,
    [PaxTypeCode.TICKET]: 156690,
};

export const PaxStringCmsCodes: Record<PaxTypeCode | 'AdultOrSenior', { singular: number; plural: number }> = {
    [PaxTypeCode.ADULT]: { singular: 126899, plural: 126898 }, // 1 adult, {0} adults
    [PaxTypeCode.SENIOR]: { singular: 126938, plural: 126937 },
    [PaxTypeCode.YOUTH]: { singular: 126940, plural: 126939 },
    [PaxTypeCode.CHILD]: { singular: 126901, plural: 126900 },
    [PaxTypeCode.INFANT]: { singular: 126903, plural: 126902 },
    [PaxTypeCode.PERSON]: { singular: 126942, plural: 126941 },
    [PaxTypeCode.BOOK]: { singular: 126942, plural: 126941 }, // Same as PaxTypeCode.PERSON
    [PaxTypeCode.UNKNOWN]: { singular: 126942, plural: 126941 }, // Same as PaxTypeCode.PERSON
    [PaxTypeCode.TODDLER]: { singular: 156700, plural: 156697 },
    [PaxTypeCode.STUDENT]: { singular: 156701, plural: 156698 },
    [PaxTypeCode.TICKET]: { singular: 156702, plural: 156699 },
    AdultOrSenior: { singular: 223454, plural: 223455 },
};
